import { NotificationBell } from '@flobi/asset-library/notifications';
import { tip } from '../ui/tooltip';
import { Icon } from '../editor/chrome/icons';

/**
 * Flobi's one bell, beside Home's workspace menu and in the editor's top bar: it opens the Centre
 * (`notifications/ArtworkNotifications`, mounted at the root), so it holds no data of its own. Its
 * look comes from the page's CSS (`.art-bell`, `.toolbar-bell` in index.css).
 */
export function Notifications({ toolbar = false }: { toolbar?: boolean } = {}) {
  return (
    <span className="contents" {...tip('Notifications', 'N')}>
      <NotificationBell className="art-bell" size={18}>
        {toolbar ? <Icon name="toolbar-notifications" size={18} /> : null}
      </NotificationBell>
    </span>
  );
}
